import { useContext, useEffect, useMemo, useState } from "react";
import { AppContext } from "../State/Context";
import { ActionType } from "../State/State";
import useAsyncEffect from "use-async-effect";
import { requestHexagenInfo } from "../api/hexagen";
import { Card } from "../Card/Card";
import { EmojiFireworks } from "../components/EmojiFireworks";

export const GenerationFinishedPopup: React.FC = () => {
  const { state, dispatch } = useContext(AppContext);
  const [showFireworks, setShowFireworks] = useState(false);
  const zIndex = useMemo(() => {
    return Math.floor(Date.now() / 1000);
  }, []);

  const coordinates = state.awardPopupCoordinates;
  const selectedHexInfo = state.selectedHexInfo;


  useAsyncEffect(async () => {
    if (coordinates) {
      await requestHexagenInfo(coordinates.x, coordinates.y);
    }
  }, [coordinates?.x, coordinates?.y]);

  useEffect(() => {
    setShowFireworks(false);
    const t = setTimeout(() => setShowFireworks(true), 500);
    return () => clearTimeout(t);
  }, [selectedHexInfo?.uid]);

  if (!selectedHexInfo) {
    return null;
  }

  const closePopup = () => {
    const next = state.awardPopupQueue?.[0];
    dispatch({ type: ActionType.CLOSE_GENERATED_AWARD_POPUP });
    if (next) {
      dispatch({ type: ActionType.DEQUEUE_GENERATED_AWARD_POPUP });
      setTimeout(() => {
        dispatch({
          type: ActionType.OPEN_GENERATED_AWARD_POPUP,
          coordinates: { x: next.x, y: next.y },
        });
      }, 500);
    }
  };

  const bgClickHandler = (event: React.MouseEvent<HTMLDivElement>) => {
    if (event.target === event.currentTarget) {
      closePopup();
    }
  };

  return (
    <div
      onClick={bgClickHandler}
      className={`fixed  appear-from-opacity-40 shadow inset-0 flex justify-center items-start z-[10000]`}
      style={{
        perspective: "1000px",
        zIndex: zIndex,
      }}
    >
      <EmojiFireworks active={showFireworks} />
      <div
        className={`appear-from-bottom w-full max-w-[420px] px-2 sm:ml-8 mt-[73px] relative`}
        style={{ zIndex: 10000 }}
      >
        <Card
          selectedHexCoord={{ x: selectedHexInfo.x, y: selectedHexInfo.y }}
          hexagenInfo={selectedHexInfo}
          hexagenExtra={state.selectedHexExtra || undefined}
          onCloseHandler={closePopup}
          setSparks={() => {}}
        />
      </div>
    </div>
  );
};
